import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";
import SSOView from "../views/SSO.vue";
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    // Is called from purple app or mobile app
    // Using wildcard to capture full URL including slashes
    path: "/sso/saml/:providerUrl(.*)",
    name: "sso",
    component: SSOView,
  },
  {
    path: "/ssoready/callback",
    name: "ssoready-callback",
    component: SSOView,
  },
  {
    path: "/sso/callback",
    name: "sso-callback",
    component: SSOView,
  },
  {
    path: "/404",
    name: "page-not-found",
    component: import(/* webpackChunkName: "about" */ "../views/404.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "page-not-found",
    component: import(/* webpackChunkName: "about" */ "../views/404.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
